import styled from 'styled-components'
import { PageTitle } from 'domain/feature/hub/pageTitle/styles'

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  align-self: stretch;
  box-sizing: border-box;
  gap: 1rem;
`

export const TitleBlock = styled.div`
  flex: 1;
  min-width: 0;
`

export const ScoutingPageTitle = styled(PageTitle)`
  display: block;
  max-width: 100%;
  overflow: visible;
  text-overflow: unset;
  white-space: normal;
  word-break: break-word;
  -webkit-line-clamp: unset;
  -webkit-box-orient: unset;
`

export const IconButtonsWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: 0.5rem;
`

export const IconButton = styled.button`
  border: none;
  background: #A0D6FF;
  color: #00599C;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #8BC5FF;
  }
`
